import * as React from "react";
import { Textarea } from "./textarea";
import { cn } from "@/lib/utils";

interface TextareaWithCountProps extends React.ComponentProps<"textarea"> {
  maxLength?: number;
  showCount?: boolean;
}

const TextareaWithCount = React.forwardRef<HTMLTextAreaElement, TextareaWithCountProps>(
  ({ className, maxLength = 500, showCount = true, value, onChange, ...props }, ref) => {
    const [count, setCount] = React.useState(0);

    React.useEffect(() => {
      const currentValue = value?.toString() || "";
      setCount(currentValue.length);
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const newValue = e.target.value;
      if (newValue.length <= maxLength) {
        setCount(newValue.length);
        onChange?.(e);
      }
    };

    const isNearLimit = count >= maxLength * 0.9;
    const isAtLimit = count >= maxLength;

    return (
      <div className="relative w-full">
        <Textarea
          ref={ref}
          className={cn("resize-y pr-3 pb-2", className)}
          value={value}
          onChange={handleChange}
          maxLength={maxLength}
          {...props}
        />
        {showCount && (
          <div
            className={cn(
              "absolute bottom-2 right-3 text-xs tabular-nums pointer-events-none",
              isAtLimit
                ? "text-destructive"
                : isNearLimit
                  ? "text-amber-600 dark:text-amber-500"
                  : "text-muted-foreground"
            )}
          >
            {count}/{maxLength}
          </div>
        )}
      </div>
    );
  }
);

TextareaWithCount.displayName = "TextareaWithCount";

export { TextareaWithCount };
